import { gql } from '@apollo/client';

const FileFragment = gql`
  fragment File on File {
    _id
    name
    size
    type
    s3Key
    publicUrl
    status
    thumbnailFileUrl
  }
`;

const EditMediaFileInput = gql`
  input EditMediaFileInput {
    name: String!
  }
`;

export { FileFragment, EditMediaFileInput };
